//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"

//#region Public Types

export const DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_NAME = 'deviceConnectionContextMenuService'
export const DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'deviceConnectionContextMenuServiceProvider'

export type IdDeviceConnectionGridContextMenuOptions = {
    idReferenceTypes?: number[]
    showParentDetails: () => void
    showDetails: (e: any) => void
    onShowDevices: () => void
    onShowParentDevices: () => void
}

//#endregion

export class DeviceConnectionContextMenuService {

    // #region Ctor

    public constructor(
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdDeviceConnectionGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (_.size(options.idReferenceTypes) > 0) {
            if (_.size(options.idReferenceTypes) === 1 && this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)) {

                if (options.showParentDetails != null) {

                    items.push({
                        beginGroup: true,
                        template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.HubDetails), ConfigHelper.Icon.DETAILS, this.userSessionService),
                        onItemClick: () => {
                            options.showParentDetails()
                        },
                    })
                }

                if (options.showDetails != null) {
                    items.push({
                        template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RadioDeviceDetails), ConfigHelper.Icon.DETAILS, this.userSessionService),
                        onItemClick: (e: any) => {
                            options.showDetails(e)
                        }
                    })
                }
            }

            if (options.onShowDevices != null) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowHubs), ConfigHelper.Icon.DETAILS_PREVIEW, this.userSessionService),
                    onItemClick: () => {
                        options.onShowDevices()
                    },
                })
            }

            if (options.onShowParentDevices != null) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowRadioDevices), ConfigHelper.Icon.DETAILS_PREVIEW, this.userSessionService),
                    onItemClick: () => {
                        options.onShowParentDevices()
                    }
                })
            }
        }

        return items
    }

    // #endregion
}

export class DeviceConnectionsContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new DeviceConnectionContextMenuService(userSessionService)
    }]

    //#endregion
} 
